import React from 'react';
import PropTypes from 'prop-types';

import {
  PrimaryButton,
  ButtonIcon,
  ButtonText,
} from '@prisjakt/ui/button/variants';
import { Spinner } from 'src/components/spinner';

const SubmitButton = props => {
  const { text, loading, style, onClick, className, type, htmlType } = props;

  return (
    <PrimaryButton
      className={className}
      onClick={onClick}
      style={style}
      loading={loading}
      htmlType={type || htmlType}
    >
      {!loading && <ButtonText>{text}</ButtonText>}

      {loading && (
        <ButtonIcon>
          <Spinner position="none" isActive />
        </ButtonIcon>
      )}
    </PrimaryButton>
  );
};

SubmitButton.propTypes = {
  loading: PropTypes.bool,
  type: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

SubmitButton.defaultProps = {
  type: 'submit',
  loading: false,
};

export default SubmitButton;
